import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import MyApp from './components/MyApp';
const router = createBrowserRouter([{ path: '/', element: <MyApp /> }]);
function App() {
	return <RouterProvider router={router}></RouterProvider>;
}

export default App;
